import MainContent from 'components/MainContent';
import Footer from 'components/Footer';
import { WebFrameHeader } from 'components/WebFrameHeader/WebFrameHeader';
import { useUserContext } from 'contexts/AuthProvider';
import { Header } from 'semantic-ui-react';
import { Claims, ModuleUriParams, NavigationItemDto, UserInfo } from 'types/types';
import { moduleNameToEnum } from 'utils/helpers';
import { t } from 'utils/resources';
import { useParams } from 'react-router-dom';
import { ModuleEnum } from 'utils/enums';
import ErrorPage from 'components/ErrorPage';

interface WebframePageLimitedProps {
  handleHelpSectionSidebar: (val: boolean) => void;
  handleUserProfileSettingsSidebar: (val: boolean) => void;
  handleNotificationSidebar: (val: boolean) => void;
  selectedFiltersChanged: (selectedFilters: string[]) => void;
  filters: NavigationItemDto[];
  filterNames: string[];
  hasUnreadNotifications: boolean;
  errorInQueryParams: boolean;
}

const HasAccessToModule = (userInfo: UserInfo, module: ModuleEnum) => {
  if (module == ModuleEnum.Briefing) {
    return userInfo.claims.some((x) => x == Claims.ExternalApprover);
  }

  return false;
};

export const WebframePageLimited = (props: WebframePageLimitedProps) => {
  const { userInfo } = useUserContext();
  const { module: moduleName } = useParams<ModuleUriParams>();
  const module = moduleNameToEnum(moduleName);
  return (
    <>
      {!HasAccessToModule(userInfo, module) && (
        <div className="no-access">
          <Header as={'h3'} inverted>
            {t('NoAccess')}
          </Header>
        </div>
      )}
      {HasAccessToModule(userInfo, module) && (
        <>
          <WebFrameHeader
            toggleHelpSectionSidebar={() => props.handleHelpSectionSidebar(true)}
            toggleUserProfileSettingsSidebar={() => props.handleUserProfileSettingsSidebar(true)}
            toggleNotificationSidebar={() => props.handleNotificationSidebar(true)}
            selectedFiltersChanged={props.selectedFiltersChanged}
            filters={props.filters}
            filterNames={props.filterNames}
            sidebar
            hasUnreadNotifications={props.hasUnreadNotifications}
          />
          {props.errorInQueryParams ? (
            <ErrorPage
              navigateToRootUrl={true}
              headerText={t('NoPermission')}
              bodyText={t('ErrorMessageForIncorrectURL')}
            />
          ) : (
            <MainContent />
          )}
          <Footer />
        </>
      )}
    </>
  );
};
